import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateName',
  standalone: true
})
export class TruncateNamePipe implements PipeTransform {

  transform(name: string, maxLength: number = 30): string {
    if (!name || name.length <= maxLength) {
      return name;
    }
    const parts = name.trim().split(/\s+/);
    const initials = parts.map(part => part.charAt(0).toUpperCase()).join('.');
    return initials;
  }

}
